import { pickBy, isEqual } from 'lodash';
import { flatObject } from './flat-object.fn';

export function compareReplySnapshots(
  s1: any,
  s2: any
): boolean {
  const original_snapshot_simplified = pickBy(flatObject(s1), (val, key) =>
    key.match(/\.value$/)
  );
  const forged_snapshot_simplified = pickBy(flatObject(s2), (val, key) =>
    key.match(/\.value$/)
  );
  return isEqual(original_snapshot_simplified, forged_snapshot_simplified);
}
